import { redirect } from "next/navigation";
import { getSession } from "@/lib/auth/session";
import { LoginForm } from "./login-form";
import { LoginScene } from "./login-scene";

export const dynamic = "force-dynamic";

export default async function LoginPage({
  searchParams,
}: {
  searchParams: Promise<{ next?: string }>;
}) {
  const session = await getSession();
  if (session) redirect("/dashboard");

  const { next } = await searchParams;

  return (
    <LoginScene>
      <div className="w-full max-w-sm">
        <div className="rounded-xl border border-white/10 bg-black/60 shadow-2xl backdrop-blur-md">
          <div className="border-b border-white/10 px-5 py-4">
            <h2 className="text-base font-semibold tracking-tight text-white">
              Connexion
            </h2>
            <p className="mt-1 text-sm text-white/60">
              Accès réservé aux super-administrateurs.
            </p>
          </div>
          <div className="px-5 py-4">
            <LoginForm next={next} />
          </div>
        </div>
        <p className="mt-6 text-center text-[11px] text-white/55">
          Tu n&apos;es pas super-admin ?{" "}
          <span className="text-white/75">
            Connecte-toi sur ton sous-domaine tenant habituel.
          </span>
        </p>
      </div>
    </LoginScene>
  );
}
